import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PulseemResponse } from '../../Models/APIResponse';
import { PulseemReactInstance } from '../../helpers/Api/PulseemReactAPI';

// Authenticator app (Google / Microsoft Authenticator) for the logged-in user's own login.
// WebSiteAPI: Controllers/Settings/AuthenticatorController.cs (api/Authenticator/...)

export const getAuthenticatorStatus = createAsyncThunk(
    'Authenticator/Status', async (_, thunkAPI) => {
        try {
            const response = await PulseemReactInstance.get('Authenticator/Status');
            return response.data as PulseemResponse;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    })

export const startAuthenticatorSetup = createAsyncThunk(
    'Authenticator/StartSetup', async (_, thunkAPI) => {
        try {
            const response = await PulseemReactInstance.post('Authenticator/StartSetup');
            return response.data as PulseemResponse;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    })

export const activateAuthenticator = createAsyncThunk(
    'Authenticator/Activate', async (code: string, thunkAPI) => {
        try {
            const response = await PulseemReactInstance.post('Authenticator/Activate', { Code: code });
            return response.data as PulseemResponse;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    })

export const turnOffAuthenticator = createAsyncThunk(
    'Authenticator/TurnOff', async (code: string, thunkAPI) => {
        try {
            const response = await PulseemReactInstance.post('Authenticator/TurnOff', { Code: code });
            return response.data as PulseemResponse;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    })

const AuthenticatorSlice = createSlice({
    name: 'Authenticator',
    initialState: {},
    reducers: {},
    extraReducers: () => {},
})

export default AuthenticatorSlice.reducer;
